import  React from 'react';
import './parallax.sass';
import { ParallaxText } from './parallaxText';

export const Parallax = () => {
    return(
            <div className="zalupa">
                <div id="parallax">
                    
                </div>
                <div id="parallax-text">
                    <p style={{color: 'red'}}>Mr.Brock</p> 
                    <ParallaxText />
                </div>
                
            </div>
    )
}